// extracted by mini-css-extract-plugin
export default {"cls1":"CRz09wfuSvN2JcHlw4xP","cls2":"J8tMKW0p9_4lyyYXZEZA CRz09wfuSvN2JcHlw4xP"};